import axios from '../axios'

export const getProfile = (data) => {
  return axios({
      url: '/traderate/getProfile',
      method: 'get',
      data
  })
}
export const saveProfile = (data) => {
  return axios({
      url: '/traderate/saveProfile',
      method: 'post',
      data
  })
}

export const getTradeRates = (data) => {
  return axios({
      url: '/traderate/getTradeRates',
      method: 'post',
      data
  })
}
export const getBlacklist = (data) => {
  return axios({
      url: '/traderate/getBlacklist',
      method: 'post',
      data
  })
}
export const saveBlacklist = (data) => {
  return axios({
      url: '/traderate/saveBlacklist',
      method: 'post',
      data
  })
}
export const importBlacklist = (data) => {
  return axios({
      url: '/traderate/importBlacklist',
      method: 'get',
      params: {
        blockRate: data.blockRate,
        blockOrder: data.blockOrder
      },
      data
  })
}
export const delBlacklist = (data) => {
  return axios({
      url: '/traderate/delBlacklist',
      method: 'post',
      data
  })
}

export const getNoRateTrades = (data) => {
  return axios({
      url: '/traderate/getTradesWithoutRate',
      method: 'get',
      data
  })
}
export const rateAllNoRateTrades = (data) => {
  return axios({
      url: '/traderate/rateAllNoRateTrades',
      method: 'get',
      data
  })
}
export const getBlockLogs = (data) => {
  return axios({
      url: '/traderate/getBlockLogs',
      method: 'post',
      data
  })
}


// WEBPACK FOOTER //
// ./src/http/modules/traderate.js